/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** AttachmentResponseDTO */
export interface AttachmentResponseDTO {
  /** Id */
  id: number;
  /** File Path */
  file_path: string;
  /** File Name */
  file_name: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** Body_add_test_case_attachment_api_test_cases___id__attachments_post */
export interface BodyAddTestCaseAttachmentApiTestCasesIdAttachmentsPost {
  /**
   * File
   * @format binary
   */
  file: File;
}

/** Body_add_test_case_run_attachment_api_test_runs_test_cases___id__attachments_post */
export interface BodyAddTestCaseRunAttachmentApiTestRunsTestCasesIdAttachmentsPost {
  /**
   * File
   * @format binary
   */
  file: File;
}

/** Body_create_testcases_api_test_cases_post */
export interface BodyCreateTestcasesApiTestCasesPost {
  /** Title */
  title: string;
  /** Description */
  description: string;
  /** @default "DRAFT" */
  status?: TestCaseStatus;
  /**
   * Priority
   * @default 3
   */
  priority?: number;
  /** Project Ref */
  project_ref: string;
  /** Group Ref */
  group_ref?: number | null;
  /** Steps */
  steps: string;
  /** Expected Result */
  expected_result?: string | null;
  /** Precondition */
  precondition?: string | null;
  /** Postcondition */
  postcondition?: string | null;
  /** Tags */
  tags?: string | null;
  /** Attachment */
  attachment?: File | string | null;
}

/** Body_execute_test_case_run_api_test_runs_execute__test_case_run_id__put */
export interface BodyExecuteTestCaseRunApiTestRunsExecuteTestCaseRunIdPut {
  /** Description */
  description: string;
  /**
   * SUCCESS - Тест завершен успешно
   * SKIPPED - Тест пропущен
   * ERROR - Тест упал с ошибкой
   * FAILED - Тест провален
   */
  status: TestCaseRunResult;
  /** Attachment */
  attachment?: File | string | null;
}

/** Body_update_testcases_api_test_cases___id__put */
export interface BodyUpdateTestcasesApiTestCasesIdPut {
  /** Title */
  title: string;
  /** Description */
  description: string;
  /** @default "DRAFT" */
  status?: TestCaseStatus;
  /**
   * Priority
   * @default 3
   */
  priority?: number;
  /** Project Ref */
  project_ref: string;
  /** Group Ref */
  group_ref?: number | null;
  /** Steps */
  steps: string;
  /** Expected Result */
  expected_result?: string | null;
  /** Precondition */
  precondition?: string | null;
  /** Postcondition */
  postcondition?: string | null;
  /** Tags */
  tags?: string | null;
  /** Attachment */
  attachment?: File | string | null;
}

/** EmployeeCreateDTO */
export interface EmployeeCreateDTO {
  /** Name */
  name: string;
  /** Email */
  email: string;
  /** Password */
  password: string;
  /** @default "admin" */
  role?: EmployeeRole;
}

/** EmployeeListResponseDTO */
export interface EmployeeListResponseDTO {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Email */
  email: string;
  role: EmployeeRole;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** EmployeeLoginDTO */
export interface EmployeeLoginDTO {
  /** Email */
  email: string;
  /** Password */
  password: string;
}

/** EmployeePasswordUpdateDTO */
export interface EmployeePasswordUpdateDTO {
  /** Password */
  password: string;
}

/** EmployeeResponseDTO */
export interface EmployeeResponseDTO {
  /** Id */
  id: number;
  /** Name */
  name: string;
  /** Email */
  email: string;
  role: EmployeeRole;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** EmployeeRole */
export enum EmployeeRole {
  Admin = "admin",
  Superadmin = "superadmin",
}

/** EmployeeUpdateDTO */
export interface EmployeeUpdateDTO {
  /** Name */
  name: string;
  /** Email */
  email: string;
  role: EmployeeRole;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** ProjectCreateDTO */
export interface ProjectCreateDTO {
  /** Title */
  title: string;
  /** Description */
  description: string;
}

/** ProjectListResponseDTO */
export interface ProjectListResponseDTO {
  /** Id */
  id: number;
  /** Title */
  title: string;
  /** Description */
  description: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** ProjectResponseDTO */
export interface ProjectResponseDTO {
  /** Id */
  id: number;
  /** Title */
  title: string;
  /** Description */
  description: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** ProjectUpdateDTO */
export interface ProjectUpdateDTO {
  /** Title */
  title: string;
  /** Description */
  description: string;
}

/** TestCaseGroupCreateDTO */
export interface TestCaseGroupCreateDTO {
  /** Title */
  title: string;
  /** Description */
  description?: string | null;
  /**
   * Priority
   * @min 1
   * @max 5
   * @default 3
   */
  priority?: number;
  /** Project Ref */
  project_ref: number;
}

/** TestCaseGroupRefUpdateDTO */
export interface TestCaseGroupRefUpdateDTO {
  /** Group Ref */
  group_ref?: number | null;
}

/** TestCaseGroupResponseDTO */
export interface TestCaseGroupResponseDTO {
  /** Id */
  id: number;
  /** Title */
  title: string;
  /** Description */
  description?: string | null;
  /** Priority */
  priority: number;
  /** Project Ref */
  project_ref: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** TestCaseGroupUpdateDTO */
export interface TestCaseGroupUpdateDTO {
  /** Title */
  title: string;
  /** Description */
  description?: string | null;
  /**
   * Priority
   * @min 1
   * @max 5
   * @default 3
   */
  priority?: number;
  /** Project Ref */
  project_ref: number;
}

/** TestCaseListResponseDTO */
export interface TestCaseListResponseDTO {
  /** Id */
  id: number;
  /** Title */
  title: string;
  /** Description */
  description: string;
  /** @default "DRAFT" */
  status?: TestCaseStatus | null;
  /**
   * Priority
   * @default 3
   */
  priority?: number;
  /** Tags */
  tags?: string | null;
  /** Group Ref */
  group_ref?: number | null;
  /** Project Ref */
  project_ref: number;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** TestCaseResponseDTO */
export interface TestCaseResponseDTO {
  /** Id */
  id: number;
  /** Title */
  title: string;
  /** Description */
  description: string;
  /** @default "DRAFT" */
  status?: TestCaseStatus | null;
  /**
   * Priority
   * @default 3
   */
  priority?: number;
  /** Steps */
  steps: string;
  /** Expected Result */
  expected_result?: string | null;
  /** Precondition */
  precondition?: string | null;
  /** Postcondition */
  postcondition?: string | null;
  /** Tags */
  tags?: string | null;
  /** Group Ref */
  group_ref?: number | null;
  /** Project Ref */
  project_ref: number;
  /** Attachment */
  attachment?: string | null;
  /**
   * Attachments
   * @default []
   */
  attachments?: AttachmentResponseDTO[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** TestCaseRunResponseDTO */
export interface TestCaseRunResponseDTO {
  /** Id */
  id: number;
  /** Title */
  title?: string;
  /**
   * SUCCESS - Тест завершен успешно
   * SKIPPED - Тест пропущен
   * ERROR - Тест упал с ошибкой
   * FAILED - Тест провален
   * @default "WAITING"
   */
  status?: TestCaseRunResult;
  /** Test Run Ref */
  test_run_ref: number;
  /** Test Case Ref */
  test_case_ref: number;
  /** Attachment */
  attachment?: string | null;
  /** Description */
  description?: string | null;
  /**
   * Attachments
   * @default []
   */
  attachments?: AttachmentResponseDTO[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/**
 * TestCaseRunResult
 * SUCCESS - Тест завершен успешно
 * SKIPPED - Тест пропущен
 * ERROR - Тест упал с ошибкой
 * FAILED - Тест провален
 */
export enum TestCaseRunResult {
  WAITING = "WAITING",
  SUCCESS = "SUCCESS",
  SKIPPED = "SKIPPED",
  ERROR = "ERROR",
  FAILED = "FAILED",
}

/** TestCaseStatus */
export enum TestCaseStatus {
  DRAFT = "DRAFT",
  DEPRICATED = "DEPRICATED",
  READY = "READY",
}

/** TestCaseStatusUpdateDTO */
export interface TestCaseStatusUpdateDTO {
  status: TestCaseStatus;
}

/** TestPlanCreateDTO */
export type TestPlanCreateDTO = object;

/** TestPlanListResponseDTO */
export type TestPlanListResponseDTO = object;

/** TestPlanResponseDTO */
export type TestPlanResponseDTO = object;

/** TestPlanUpdateDTO */
export type TestPlanUpdateDTO = object;

/** TestRunCreateDTO */
export interface TestRunCreateDTO {
  /** Project Ref */
  project_ref: number;
  /** Plan Ref */
  plan_ref?: number | null;
  /** Version */
  version?: string | null;
  /** Branch */
  branch?: string | null;
  /** Commit */
  commit?: string | null;
  /**
   * Test Cases Run
   * @default []
   */
  test_cases_run?: number[];
}

/** TestRunListResponseDTO */
export interface TestRunListResponseDTO {
  /** Id */
  id: number;
  /** Project Ref */
  project_ref: number;
  /** Plan Ref */
  plan_ref?: number | null;
  /** Version */
  version?: string | null;
  /** Branch */
  branch?: string | null;
  /** Commit */
  commit?: string | null;
  /**
   * Statistics
   * @default []
   */
  statistics?: TestRunStatisticsItem[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** TestRunResponseDTO */
export interface TestRunResponseDTO {
  /** Id */
  id: number;
  /** Project Ref */
  project_ref: number;
  /** Plan Ref */
  plan_ref?: number | null;
  /** Version */
  version?: string | null;
  /** Branch */
  branch?: string | null;
  /** Commit */
  commit?: string | null;
  /**
   * Test Cases Run
   * @default []
   */
  test_cases_run?: TestCaseRunResponseDTO[];
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
}

/** TestRunStatisticsItem */
export interface TestRunStatisticsItem {
  /**
   * SUCCESS - Тест завершен успешно
   * SKIPPED - Тест пропущен
   * ERROR - Тест упал с ошибкой
   * FAILED - Тест провален
   * @default "WAITING"
   */
  status?: TestCaseRunResult;
  /**
   * Count
   * @default 0
   */
  count?: number;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}
